export enum ApplicationProcess {
	Unknown = 0,
	RbfCl = 1,
	RbfOvd = 2,
	LightCl = 4,
	LightOvd = 8,
}
